export default __webpack_public_path__ + "static/media/atopic-dermatitis.48dfde39.JPG";